import { Text, useStyleConfig } from '@tectonic/elemason-components';
import { Clickable } from '@tectonic/uikit';
import clsx from 'clsx';
import { Center, MediaAsset } from '../../components';
import { useActionDispatch } from '../../hooks';

import type {
  ElemasonBannerListWidgetConfig,
  ElemasonBannerListWidgetItemData,
} from '@tectonic/types';
import type { FC } from 'react';

interface BannerListItemProps {
  item: ElemasonBannerListWidgetItemData;
  config?: ElemasonBannerListWidgetConfig;
  onClick?: (item: ElemasonBannerListWidgetItemData) => void;
}

const BannerListItem: FC<BannerListItemProps> = ({ onClick, item, config }) => {
  const { text, banner: bannerConfig, itemContainer } = config ?? {};
  const dispatch = useActionDispatch();
  const { style, className } = useStyleConfig(itemContainer ?? {});
  const bannerContainerProps = useStyleConfig(bannerConfig?.container ?? {});
  const imageProps = useStyleConfig(bannerConfig?.asset ?? {});

  const handlePress = () => {
    onClick?.(item);
    item.actions?.onClick.forEach((action) => dispatch(action, item));
  };

  if (item.actions?.onClick.length || onClick) {
    return (
      <Clickable onClick={handlePress}>
        <Center style={style} className={clsx('flex-col', className)}>
          <div {...bannerContainerProps}>
            <MediaAsset
              asset={item.banner}
              config={bannerConfig?.asset}
              {...imageProps}
            />
          </div>
          <Text config={text} data={item.title} />
        </Center>
      </Clickable>
    );
  }

  return (
    <Center style={style} className={clsx('flex-col', className)}>
      <div {...bannerContainerProps}>
        <MediaAsset
          asset={item.banner}
          config={bannerConfig?.asset}
          {...imageProps}
        />
      </div>
      <Text config={text} data={item.title} />
    </Center>
  );
};

BannerListItem.displayName = 'ElemasonBannerListItem';

export { BannerListItem };
